export default "__VITE_ASSET__BPGi_vdd__"